'use client'
import styled from "styled-components";
import {hover} from "@/styles/globalStyleVars";
import {Col, Container, Row} from "react-bootstrap";
import Title from "@/components/Title";
import SubTitle from "@/components/SubTitle";
import Description from "@/components/Description";

import {Img} from "@/components/Img";

const MyComponent = ({data}) => {

    return (
        <StyledComponent className={"about-us-overview pt-100 pb-100 watch-section"} id={'story'} >
            <Container>
                <Row className={'overview-row'}>
                    <Col>
                        <Title text={data?.section_data?.subtitle} margin={'0 0 40px 0'}/>
                    </Col>
                </Row>
                <Row className={'first-row'}>
                    <Col md={6}>
                        <SubTitle text={data?.section_data?.description} color={hover} fontWeight={900}/>
                        <Description text={data?.posts?.list?.[0]?.data?.description}/>
                    </Col>
                    <Col md={6}>
                        <div className="about-overview__img">
                            <Img src={data?.posts?.list?.[0]?.images?.[0]?.cdn_path} alt=""/>
                        </div>
                    </Col>
                </Row>
                <Row className={'second-row'}>
                    <Col md={6}>
                        <div className="about-overview__img">
                            <Img src={data?.posts?.list?.[1]?.images?.[0]?.cdn_path} alt=""/>
                        </div>
                    </Col>
                    <Col md={6}>
                        <Description text={data?.posts?.list?.[1]?.data?.description}/>
                    </Col>

                </Row>
            </Container>
        </StyledComponent>
    );

};

const StyledComponent = styled.section`
    will-change: transform;
    .about-overview__img{
        position: relative;
        padding-top: calc(400 / 570 * 100%);
        img{
            border-radius: 10px;
        }
    }
    .first-row{
        margin-bottom: 40px;
    }
    @media(max-width: 991px){
        .first-row{
            display: flex;
            flex-direction: column;
            .col-md-6{
                flex: 0 0 100%;
                max-width: 100%;
            }
        }
        .about-overview__img{
            margin-top: 30px;
        }
        .second-row{
            display: flex;
            flex-direction: column-reverse;
            .col-md-6{
                flex: 0 0 100%;
                max-width: 100%;
            }
        }
    }
`;

export default MyComponent;
